export const Creators = [
  {
    id: 1,
    name: "A",
    job: "브랜드 디자이너",
    positionX: 127.04974020993444,
    positionY: 37.07684278859075,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
  {
    id: 2,
    name: "B",
    job: "브랜드 디자이너",
    positionX: 127.04812021049855,
    positionY: 37.07588832196605,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
  {
    id: 3,
    name: "C",
    job: "브랜드 디자이너",
    positionX: 127.0521681183984,
    positionY: 37.07511168977113,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
  {
    id: 4,
    name: "D",
    job: "브랜드 디자이너",
    positionX: 127.0464552365888,
    positionY: 37.07487978641702,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
  {
    id: 5,
    name: "E",
    job: "브랜드 디자이너",
    positionX: 127.0464552365888,
    positionY: 37.07487978641702,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
  {
    id: 6,
    name: "A",
    job: "브랜드 디자이너",
    positionX: 127.04974020993444,
    positionY: 37.07684278859075,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
  {
    id: 7,
    name: "A",
    job: "브랜드 디자이너",
    positionX: 127.04974020993444,
    positionY: 37.07684278859075,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    tag: ["예술", "벽화", "지역사회"],
  },
];

export const Projects = [
  {
    id: 8,
    name: "A",
    director: "김수한",
    member: [
      {
        name: "김",
        job: "공간 디자이너",
        positionX: 127.04974020993444,
        positionY: 37.07684278859075,
      },
      {
        name: "김수",
        job: "공간 디자이너",
        positionX: 127.04812021049855,
        positionY: 37.07588832196605,
      },
      {
        name: "김수한무",
        job: "공간 디자이너",
        positionX: 127.0521681183984,
        positionY: 37.07511168977113,
      },
    ],
    applicants: [
      { name: "거북이", job: "공간 디자이너" },
      { name: "거북이", job: "공간 디자이너" },
      { name: "거북이", job: "공간 디자이너" },
      { name: "거북이", job: "공간 디자이너" },
    ],
    positionX: 127.04974020993444,
    positionY: 37.07684278859075,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    fieldTag: ["로컬사업", "디자인", "마케팅"],
    tag: ["예술", "벽화", "지역사회"],
    initialDate: "2021-12-25",
    dDay: "2022-02-04",
  },
  {
    id: 9,
    name: "B",
    director: "김수한",
    member: [
      {
        name: "김",
        job: "공간 디자이너",
        positionX: 127.04974020993444,
        positionY: 37.07684278859075,
      },
      {
        name: "김수",
        job: "공간 디자이너",
        positionX: 127.04812021049855,
        positionY: 37.07588832196605,
      },
      {
        name: "김수한무",
        job: "공간 디자이너",
        positionX: 127.0521681183984,
        positionY: 37.07511168977113,
      },
    ],
    applicants: [],
    positionX: 127.04812021049855,
    positionY: 37.07588832196605,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    fieldTag: ["로컬사업", "디자인", "마케팅"],
    tag: ["예술", "벽화", "지역사회"],
    initialDate: "2021-12-26",
    dDay: "2022-01-06",
  },
  {
    id: 10,
    name: "C",
    director: "김수한",
    member: [
      {
        name: "김",
        job: "공간 디자이너",
        positionX: 127.04974020993444,
        positionY: 37.07684278859075,
      },
      {
        name: "김수",
        job: "공간 디자이너",
        positionX: 127.04812021049855,
        positionY: 37.07588832196605,
      },
      {
        name: "김수한무",
        job: "공간 디자이너",
        positionX: 127.0521681183984,
        positionY: 37.07511168977113,
      },
    ],
    applicants: [{ name: "거북이", job: "공간 디자이너" }],
    positionX: 127.0521681183984,
    positionY: 37.07511168977113,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    fieldTag: ["로컬사업", "디자인", "마케팅"],
    tag: ["예술", "벽화", "지역사회"],
    initialDate: "2021-12-27",
    dDay: "2022-02-08",
  },
  {
    id: 11,
    name: "D",
    director: "김수한",
    member: [
      {
        name: "김",
        job: "공간 디자이너",
        positionX: 127.04974020993444,
        positionY: 37.07684278859075,
      },
      {
        name: "김수",
        job: "공간 디자이너",
        positionX: 127.04812021049855,
        positionY: 37.07588832196605,
      },
      {
        name: "김수한무",
        job: "공간 디자이너",
        positionX: 127.0521681183984,
        positionY: 37.07511168977113,
      },
    ],
    applicants: [{ name: "거북이", job: "공간 디자이너" }],
    positionX: 127.0464552365888,
    positionY: 37.07487978641702,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    fieldTag: ["로컬사업", "디자인", "마케팅"],
    tag: ["예술", "벽화", "지역사회"],
    initialDate: "2021-12-28",
    dDay: "2022-01-04",
  },
  {
    id: 12,
    name: "E",
    director: "김수한",
    member: [
      {
        name: "김",
        job: "공간 디자이너",
        positionX: 127.04974020993444,
        positionY: 37.07684278859075,
      },
      {
        name: "김수",
        job: "공간 디자이너",
        positionX: 127.04812021049855,
        positionY: 37.07588832196605,
      },
      {
        name: "김수한무",
        job: "공간 디자이너",
        positionX: 127.0521681183984,
        positionY: 37.07511168977113,
      },
    ],
    applicants: [{ name: "거북이", job: "공간 디자이너" }],
    positionX: 127.0464552365888,
    positionY: 37.07487978641702,
    intro: "팔달구의 낙후된 골목을 예술 벽화를 통해 개선하는 프로젝트 입니다.",
    fieldTag: ["로컬사업", "디자인", "마케팅"],
    tag: ["예술", "벽화", "지역사회"],
    initialDate: "2021-12-29",
    dDay: "2022-01-04",
  },
];
